import React, { useContext, useEffect, useState } from "react";
import { ChoiceList } from "@cmsgov/ds-medicare-gov";
import { AppStore } from "../../../app/store";
import {
  addNewRelicPageAction,
  sendTealiumEvent,
  useTranslate,
} from "../../../helpers";
import { CCXPMultiSelect } from "../../../components";
import { default as C, SearchFilterKeys } from "./constants";
import { PlanType } from "../../../@types";
import { searchResultsFilterAnalytics } from "./helpers";
import { useFlags } from "launchdarkly-react-client-sdk";

export interface Props {
  onFilterUpdate: (filters: string[]) => void;
  basicMode?: boolean;
}

const PlanCoveragesFilter: React.FunctionComponent<Props> = ({
  onFilterUpdate,
  basicMode,
}) => {
  const {
    state: { planType, searchResultsFilters },
    state,
  } = useContext(AppStore.AppContext);
  const t = useTranslate();
  const flags = useFlags();
  const [currentCoverageSelections, setCurrentCoverageSelections] = useState(
    searchResultsFilters.planCoveragesFilter
  );

  const updateFilters = (newFilterValues: string[]): void => {
    newFilterValues.forEach(value => {
      addNewRelicPageAction("Search Results Filter", {
        filter: "Plan Coverages Filter",
        value: newFilterValues.toString(),
      });
      if (value in C.TealiumConversions) {
        searchResultsFilterAnalytics({
          state,
          flags,
          filterValue: C.TealiumConversions[value],
          filterType: SearchFilterKeys.planCoveragesFilter,
        });
        sendTealiumEvent(
          "Find Plans - Available Plans",
          C.TealiumConversions[value] || ""
        );
      }
    });
    onFilterUpdate(newFilterValues);
  };

  useEffect(() => {
    setCurrentCoverageSelections(searchResultsFilters.planCoveragesFilter);
  }, [searchResultsFilters]);

  if (!planType || planType === PlanType.PDP) {
    return null;
  }

  const label = t("search_results_page.filters.plan_with_these_benefits");
  const choices = Object.entries(C.filtersByPlan[planType]).map(
    ([filterKey, filterName]) => ({
      checked: !!currentCoverageSelections.includes(filterName),
      label: t(C.filterLabels[filterKey]),
      value: filterName,
    })
  );

  return basicMode ? (
    <ChoiceList
      name="OpenPlanCoveragesFilter"
      type="checkbox"
      label={<p className="PlanFilters__action__label">{label}</p>}
      className="PlanFilters__filterGroupHeading ds-u-margin--0"
      onChange={event => {
        const { checked, value } = event.currentTarget;
        const selected =
          checked && !currentCoverageSelections.includes(value)
            ? [...currentCoverageSelections, value]
            : currentCoverageSelections.filter(f => f !== value);
        setCurrentCoverageSelections(selected);
        updateFilters(selected);
      }}
      choices={choices}
    />
  ) : (
    <div className="Filter">
      <CCXPMultiSelect
        label={label}
        values={currentCoverageSelections}
        options={choices}
        onUpdate={updateFilters}
      />
    </div>
  );
};

export default PlanCoveragesFilter;
